// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6243) return "static/chunks/6243-58c0346410bf8c2c.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3846 ? "59ae8a9c" : chunkId) + "." + {"1715":"ba27ff8c2e6fb22a","3846":"56dae21ff63103f4"}[chunkId] + ".js";
};